export default __webpack_public_path__ + "static/media/credit-card-edit.ec2eb7c4.svg";